import {useState} from 'react'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {AxiosError} from 'axios'
import * as bootstrap from 'bootstrap'
import {addUser} from '../../../../modules/auth/core/_requests'
import {KTSVG} from '../../../../../_metronic/helpers'
import {SuccessfulNotify, UnsuccessfulNotify} from '../../../../../ToastMetods'
import {useNavigate} from 'react-router-dom'
import {useIntl} from 'react-intl'

const profileDetailsSchema = Yup.object().shape({
  firstName: Yup.string().required('First name is required').max(100, 'Maximum 100 character'),
  lastName: Yup.string().required('Last name is required').max(100, 'Maximum 100 character'),
  email: Yup.string()
    .email('Wrong email format')
    .min(0, 'Minimum 0 symbols')
    .max(250, 'Maximum 250 symbols')
    .required('Email is required'),
  password: Yup.string()
    .min(8, 'Minimum 8 symbols')
    .max(15, 'Maximum 15 symbols')
    .matches(/[a-z]/, 'Password requires a lowercase letter')
    .matches(/[A-Z]/, 'Password requires an uppercase letter')
    .matches(/[\d]/, 'Password requires a numeric expression')
    .matches(/[#?!@$%^&*-./]/, 'Password requires one special character')
    .required('Password is required'),
})

function AddUserModal({setAction, page, rowsPerPage}: any) {
  const intl = useIntl()
  const [loading, setLoading] = useState(false)
  const [emailConfirm, setEmailConfirm] = useState(true)
  const navigate = useNavigate()

  const initialValues = {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    telefon: '',
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: profileDetailsSchema,
    onSubmit: async (values) => {
      setLoading(true)

      try {
        const {data} = await addUser(
          values.firstName,
          values.lastName,
          values.email,
          values.password,
          emailConfirm,
          values.telefon
        )

        formik.resetForm()
        //Modal close
        const modal = bootstrap.Modal.getOrCreateInstance('#addUserModal')
        modal.hide()
        //
        SuccessfulNotify('Registration Successfully Added.')
        //setAction(true)
        navigate('/management/users/selected-user', {
          state: {row: data, page, rowsPerPage},
        })
        setLoading(false)
      } catch (err) {
        const error = `${(err as AxiosError)?.response?.data}`
        console.error(error)
        UnsuccessfulNotify(String(error))
        setLoading(false)
      }
    },
  })

  return (
    <div className='modal fade' tabIndex={-1} id='addUserModal'>
      <div className='modal-dialog'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>{intl.formatMessage({id: 'USER.ADDUSER'})}</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body'>
            <form onSubmit={formik.handleSubmit} noValidate className='form'>
              <div className='modal-body'>
                {/*From*/}

                <div className='mb-10'>
                  <label className='form-label'>{intl.formatMessage({id: 'USER.FIRSTNAME'})}</label>
                  <input
                    type='text'
                    className='form-control'
                    placeholder={intl.formatMessage({id: 'USER.FIRSTNAME'})}
                    {...formik.getFieldProps('firstName')}
                  />
                  {formik.touched.firstName && formik.errors.firstName && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.firstName}</div>
                    </div>
                  )}
                </div>

                <div className='mb-10'>
                  <label className='form-label'>{intl.formatMessage({id: 'USER.LASTNAME'})}</label>
                  <input
                    type='text'
                    className='form-control '
                    placeholder={intl.formatMessage({id: 'USER.LASTNAME'})}
                    {...formik.getFieldProps('lastName')}
                  />
                  {formik.touched.lastName && formik.errors.lastName && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.lastName}</div>
                    </div>
                  )}
                </div>

                <div className='mb-10'>
                  <label className='form-label'>{intl.formatMessage({id: 'USER.EMAIL'})}</label>
                  <input
                    type='email'
                    className='form-control form-control-white'
                    placeholder={intl.formatMessage({id: 'USER.EMAIL'})}
                    {...formik.getFieldProps('email')}
                  />
                  {formik.touched.email && formik.errors.email && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.email}</div>
                    </div>
                  )}
                </div>

                <div className='mb-10'>
                  <label className='form-label'>{intl.formatMessage({id: 'USER.PASSWORD'})}</label>
                  <input
                    type='password'
                    className='form-control form-control-white'
                    placeholder={intl.formatMessage({id: 'USER.PASSWORD'})}
                    {...formik.getFieldProps('password')}
                  />
                  {formik.touched.password && formik.errors.password && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.password}</div>
                    </div>
                  )}
                </div>

                <div className='mb-10'>
                  <label className='form-label'>Telefon</label>
                  <input
                    type='tel'
                    className='form-control form-control-white'
                    placeholder={'Telefon'}
                    {...formik.getFieldProps('telefon')}
                  />
                </div>

                <div className='mb-10'>
                  <label className='form-label'>
                    {intl.formatMessage({id: 'USER.EMAILCONFIRM'})}
                  </label>
                  <div className='form-check'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      name={`emailConfirmCheckBox`}
                      id={`emailConfirmCheckBox`}
                      checked={emailConfirm}
                      onChange={() => setEmailConfirm(!emailConfirm)}
                    />

                    <label className='form-check-label' htmlFor={`emailConfirmCheckBox`}>
                      {emailConfirm
                        ? intl.formatMessage({id: 'USER.APPROVED'})
                        : intl.formatMessage({id: 'USER.NOTAPPROVED'})}
                    </label>
                  </div>
                </div>

                {/*End Form */}
              </div>
              <div className='modal-footer'>
                <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
                  {intl.formatMessage({id: 'CLOSE'})}
                </button>

                <button type='submit' className='btn btn-primary'>
                  {intl.formatMessage({id: 'SETTING.SAVE_CHANGES'})}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddUserModal
